// Copyright (c) 2026 Riddle, LLC. All rights reserved.
// Author: Ray Harris

export { SIGNED_OUT_MESSAGE as SIGNED_OUT_WRITE_BODY } from "../../../services/api/demoData";
export { PERMISSION_DENIED_MESSAGE } from "../../../services/api/userFacingError";

export const SIGN_IN_AGAIN_LABEL = "Sign In Again";
export const SIGNED_OUT_CLOSE_NEW_TASK_TITLE = "Close New Task?";
export const SIGNED_OUT_CLOSE_EDIT_TITLE = "Close Without Saving?";
export const SIGNED_OUT_CLOSE_TASK_BODY =
  "You're signed out, so this task can't be saved yet. Keep it as a draft and we'll restore it when you reopen it.";
export const SIGNED_OUT_READ_BODY = "Your session ended, so we couldn't load this.";

export function signedOutReadTitle(objects: string): string {
  return `Sign in to see your ${objects}`;
}
